/**
 * CityProximityBanner - Shows a subtle banner when the user is near a city page
 * @atomic @idempotent
 */
import { memo } from 'react'
import { Link } from 'react-router-dom'
import { MapPinIcon, XMarkIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

const CityProximityBanner = memo(function CityProximityBanner({ city, distanceKm, onDismiss }) {
  if (!city) return null

  const label = city.region_code
    ? `${city.name}, ${city.region_code}`
    : city.name

  return (
    <div className="flex items-center gap-2 px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm text-gray-700 shadow-md">
      <MapPinIcon className="h-4 w-4 text-primary flex-shrink-0" />
      <span className="flex-1 min-w-0">
        You&apos;re near{' '}
        <Link
          to={`/city/${city.slug}`}
          className="font-semibold text-primary hover:underline"
        >
          {label}
        </Link>
        {distanceKm != null && (
          <span className="text-gray-400 text-xs ml-1">({distanceKm} km away)</span>
        )}
      </span>
      <Link
        to={`/city/${city.slug}`}
        className="flex items-center gap-0.5 text-xs font-medium text-primary hover:underline flex-shrink-0"
      >
        See vendors
        <ChevronRightIcon className="h-3.5 w-3.5" />
      </Link>
      <button
        onClick={onDismiss}
        onTouchEnd={onDismiss}
        aria-label="Dismiss"
        className="p-1 rounded text-gray-400 hover:text-gray-600 flex-shrink-0"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  )
})

export default CityProximityBanner
